import React from 'react';

import initPolyglot from '~/src/utilities/libs/polyglot';
import {withSitemapContext} from '~/src/components/context/SitemapContext';
import {getCookie, setCookie} from '~/src/utilities/helpers/cookie';
import {Cookie} from '~/src/utilities/constants/cookie';
import {getRootPath} from '~/src/utilities/helpers/link';

import css from './LanguageInfoBar.module.scss';
import i18nStrings from './LanguageInfoBar.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class LanguageInfoBar extends React.Component {
    saveLanguage(lang) {
        setCookie(Cookie.LANGUAGE, lang);
        window.location.href = getRootPath(lang);
    }

    showBanner = () => {
        if (!getCookie(Cookie.LANGUAGE) && navigator.language && navigator.language.includes('fr') && location.pathname === '/') {
            this.setState({showBanner: true});
        }
    };

    state = {
        showBanner: false
    };

    componentDidMount() {
        this.showBanner();
    }

    render() {
        if (!this.state.showBanner) {
            return null;
        }
        return (
            <div className={css.languageInfoBar} data-testid="languageInfoBar">
                <div className={css.languageInfoBarContainer}>
                    <span>{getTranslation('languageInfoPart1')}</span>
                    <button className={css.languageButton} onClick={() => this.saveLanguage('fr')}>
                        {getTranslation('languageInfoPart2')}
                    </button>
                    <span>{getTranslation('languageInfoPart3')}</span>
                    <button className={css.languageButton} onClick={() => this.saveLanguage('de')}>
                        {getTranslation('languageInfoPart4')}
                    </button>
                </div>
            </div>
        );
    }
}

export default withSitemapContext(LanguageInfoBar);
